import Light from './Light'

export const VerofamiliaLight = Light
export const VerofamiliaDark = Light
